import { useOutletContext } from 'react-router';

export function usePipelineDrawer() {
  return useOutletContext<PipelineDrawerContext>();
}

type PipelineDrawerContext = {
  pipelinesRootPath: string;
};
